import React from "react"

import { DomesticSettlement } from "components/organisms/panel/calendar"
import { APIResponse } from "redux/apis/types"
import { MainContainer } from "components/molecules/utils/mainContainer"

type Props = {
  calenderData: APIResponse.Res | {}
  settlementMonth: number
  changeSettlementMonth: Function
  displayType: object
  changeDisplayType: Function
  foreignCurrentPage: number
  foreignChangePage: Function
}

export const SettlementTemplate = (props: Props) => {
  return (
    <MainContainer>
      <div className="contents-block">
        <DomesticSettlement
          calenderData={props.calenderData}
          settlementMonth={props.settlementMonth}
          changeSettlementMonth={props.changeSettlementMonth}
          displayType={props.displayType}
          changeDisplayType={props.changeDisplayType}
          foreignCurrentPage={props.foreignCurrentPage}
          foreignChangePage={props.foreignChangePage}
        />
      </div>
    </MainContainer>
  )
}
